<section class="grid gap-4">
  <div>
    <page-title [title]="'Create managed user'"></page-title>
  </div>

  <register-user
    [busy]="userStore.saving()"
    [createdUser]="userStore.selectedUser()"
    [clients]="clientStore.clients()"
    [portals]="lookupStore.portals()"
    [userRoles]="lookupStore.userRoles()"
    [affiliateOptions]="affiliateOptions()"
    [affiliateOptionsLoading]="affiliateStore.affiliateLookupLoading()"
    (submitted)="createUser($event)"
    (affiliateSearchChanged)="affiliateSearchChanged($event)"
  />
</section>